import { useEffect, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import { config } from '../../../config/config';

import { getCookie, setCookie } from './use-cookie';

export function useMarketingSourceParams() {
    const [params] = useSearchParams();

    return useMemo(() => {
        const marketingSourceParams = config.MARKETING_SOURCE_PARAMS.map((key) => {
            return { key: key, value: params.get(key) };
        });
        return marketingSourceParams.filter((item) => !!item.value);
    }, [params]);
}

export function useMarketingSources() {
    const paramsKeyValue = useMarketingSourceParams();

    useEffect(() => {
        paramsKeyValue.map((item) => {
            if (item.key && item.value) {
                setCookie(item.key, item.value, config.MARKETING_SOURCE_COOKIE_EXPIRY);
            }
        });
    }, [paramsKeyValue]);

    return useMemo(() => {
        const allCookies = config.MARKETING_SOURCE_PARAMS.map((item) => {
            return { key: item, value: getCookie(item) };
        }).filter(function (item) {
            return item.value !== null;
        });

        return allCookies.map((item) => {
            if (item?.value) {
                return item.value;
            }
        });
    }, []);
}
